// Copyright (C) 2020-2022 Intel Corporation
// Copyright (C) 2022 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import React from 'react';
import { connect } from 'react-redux';
import { ReferencesState, ReferencesQuery, CombinedState } from 'reducers';
import ReferencesListComponent from 'components/references-page/reference-list';
import { getReferencesAsync } from 'actions/references-actions';

interface StateToProps {
    references: ReferencesState;
}

interface DispatchToProps {
    getReferences: (query: ReferencesQuery) => void;
}

function mapStateToProps(state: CombinedState): StateToProps {
    return {
        references: state.references,
    };
}

function mapDispatchToProps(dispatch: any): DispatchToProps {
    return {
        getReferences: (query: ReferencesQuery): void => {
            dispatch(getReferencesAsync(query));
        },
    };
}

type ReferencesListContainerProps = StateToProps & DispatchToProps;

function ReferencesListContainer(props: ReferencesListContainerProps): JSX.Element {
    const { references } = props;

    return (
        <ReferencesListComponent
            currentReferencesIndexes={references.current.map((reference): number => reference.id)}
        />
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(ReferencesListContainer);
